<template>
    <div class="ecology-plane-comparison-container">
        <a @click="prevPage">
            <img src="/imgs/icons/icon-arrow-left.webp">
        </a>
        <div class="ecology-plane-comparison-main">
            <div class="ecology-plane-comparison-carousel">
                <div class="ecology-plane-comparison-carousel-container">
                    <div :style="{'margin-left': '-' + offset + '%'}" class="ecology-plane-comparison-carousel-container-inner">
                        <a class="plane-card" v-for="(plane, i) in planes" :key="i" :href="plane.url">
                            <img :src="plane.image">
                            <div class="plane-name">
                                {{ plane.name }}
                            </div>
                            <div class="features">
                                <div class="feature">
                                    <div class="feature-label">{{ $t('pages.co2-emissions-per-km') }}</div>
                                    <div class="feature-value">{{ plane.co2_emissions }} kg</div>
                                </div>
                                <div class="feature">
                                    <div class="feature-label">{{ $t('pages.consumption') }}</div>
                                    <div class="feature-value">{{ plane.consumption }} L / 100km*</div>
                                </div>
                            </div>
                            <div class="footer">
                                {{ $t('pages.less-than-a-jet', {percentage: plane.gain_over_jet}) }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="footnotes">
                <div>* {{ $t('pages.per-passenger') }}</div>
                <div>** {{ $t('pages.comparison-with-cessna-latitude') }}</div>
            </div>
        </div>
        <a @click="nextPage">
            <img src="/imgs/icons/icon-arrow-right.webp">
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            index: 0,
            planes: [
                {
                    name: 'Cirrus SR-22',
                    consumption: 19,
                    co2_emissions: 0.57,
                    gain_over_jet: 83,
                    image: '/imgs/ecology-plane-comparison/sr22.webp',
                    url: '/blog/jets-et-avions-prives-references/cirrus-sr22.html',
                },
                {
                    name: 'Piper Meridian',
                    consumption: 29,
                    co2_emissions: 0.82,
                    gain_over_jet: 74,
                    image: '/imgs/ecology-plane-comparison/meridian.webp',
                    url: '/blog/jets-et-avions-prives-references/piper-pa-46.html',
                },
                {
                    name: 'Diamond DA-62',
                    consumption: 20,
                    co2_emissions: 0.61,
                    gain_over_jet: 82,
                    image: '/imgs/ecology-plane-comparison/da62.webp',
                    url: '/blog/jets-et-avions-prives-references/diamond-da-62.html',
                },
                {
                    name: 'Piper Mirage',
                    consumption: 20,
                    co2_emissions: 0.61,
                    gain_over_jet: 82,
                    image: '/imgs/ecology-plane-comparison/mirage.webp',
                    url: '/blog/jets-et-avions-prives-references/piper-pa-46.html',
                },
                {
                    name: 'Daher TBM-850',
                    consumption: 38,
                    co2_emissions: 1.17,
                    gain_over_jet: 66,
                    image: '/imgs/ecology-plane-comparison/tbm850.webp',
                    url: '/blog/jets-et-avions-prives-references/daher-socata-tbm.html',
                },
                {
                    name: 'Piper PA-32',
                    consumption: 24,
                    co2_emissions: 0.71,
                    gain_over_jet: 79,
                    image: '/imgs/ecology-plane-comparison/pa32.webp',
                    url: '/blog/jets-et-avions-prives-references/piper-pa-32.html',
                },
            ],
            offset: 0,
            targetOffset: 0,
            animationSteps: 0,
            auto: true,
        };
    },
    computed: {
        isMobile() {
            return window.innerWidth < 1024;
        },
        nbPerPage() {
            return this.isMobile ? 1 : 3;
        },
    },
    watch: {
        index(value) {
            this.targetOffset = (100. / this.nbPerPage) * value;
            this.animationSteps = 40;
        },
    },
    mounted() {
        setInterval(() => {
            if (this.animationSteps > 0) {
                this.offset += (this.targetOffset - this.offset) / this.animationSteps;
                this.animationSteps--;
            }
        }, 10);
        setInterval(() => {
            if (this.isMobile && this.auto) {
                this.nextPage(false);
            }
        }, 3000);
    },
    methods: {
        prevPage(manual = true) {
            if (manual) {
                this.auto = false;
            }
            if (this.index > 0) {
                this.index--;
            } else {
                this.index = this.planes.length - this.nbPerPage;
            }
        },
        nextPage(manual = true) {
            if (manual) {
                this.auto = false;
            }
            if (this.index < this.planes.length - this.nbPerPage) {
                this.index++;
            } else {
                this.index = 0;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ecology-plane-comparison-container {
    display: flex;
    align-items: center;
    > a {
        cursor: pointer;
        flex-shrink: 0;
        > img {
            width: 40px;
        }
    }
    .ecology-plane-comparison-main {
        width: calc(100% - 80px);
        .ecology-plane-comparison-carousel {
            width: 100%;
            .ecology-plane-comparison-carousel-container {
                width: 100%;
                z-index: 2;
                overflow: hidden;
                .ecology-plane-comparison-carousel-container-inner {
                    display: flex;
                    width: 100%;
                    height: 100%;
                    .plane-card {
                        border: solid 1px #20A483;
                        border-radius: 5px;
                        display: flex;
                        flex-direction: column;
                        margin: 5px;
                        font-size: 12px;
                        min-width: calc(33.3333% - 10px);
                        max-width: calc(33.3333% - 10px);
                        color: inherit;
                        @media (max-width: 1023px) {
                            min-width: calc(100% - 10px);
                            max-width: calc(100% - 10px);
                        }
                        img {
                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;
                            width: 100%;
                        }
                        .plane-name {
                            display: flex;
                            justify-content: center;
                            color: #20A483;
                            font-weight: bold;
                            font-size: 18px;
                            margin: 20px 0 10px 0;
                        }
                        .features {
                            padding: 10px;
                            flex-grow: 1;
                            .feature {
                                display: flex;
                                justify-content: space-between;
                            }
                        }
                        .footer {
                            background-color: #20A483;
                            color: white;
                            font-weight: bold;
                            text-align: center;
                            padding: 4px;
                        }
                    }
                }
            }
        }
        .footnotes {
            margin-left: 5px;
            color: #20A483;
            font-size: 12px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EcologyPlaneComparison.vue